import Vue from "vue";
import VueRouter from "vue-router";
import { windowWidth } from "@/utils/index";

Vue.use(VueRouter);
const screenW = windowWidth();
// console.log("windowWidth************", screenW);
const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "layout" */ "@/views/home/index.vue"),
    name: "home",
    meta: {
      title: "home ",
    },
    // redirect: "/home",
    // children: [
    //   {
    //     path: "/home",
    //     name: "home",
    //     component: () => import(/* webpackChunkName: "home" */ "@/views/home/index.vue"),
    //     meta: {
    //       title: " 首页 ",
    //     },
    //   },
    // ],
  },
  // {
  //   path: "/login",
  //   component: () => import(/* webpackChunkName: "login" */ "@/views/login"),
  //   name: "login",
  //   meta: {
  //     title: "login ",
  //   },
  // },
  // {
  //   path: "/register",
  //   component: () => import(/* webpackChunkName: "register" */ "@/views/register"),
  //   name: "register",
  //   meta: {
  //     title: "register ",
  //   },
  // },
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import(/* webpackChunkName: "home" */ "../views/home/index.vue"),
  // },
];

// const routesMobile = [
//   {
//     path: "/",
//     component: () => import(/* webpackChunkName: "layout" */ "@/mobile/index.vue"),
//     name: "mobile",
//     meta: {
//       title: "mobile ",
//     },
//     redirect: "/home",
//     children: [
//       {
//         path: "/home",
//         name: "Home",
//         component: () => import(/* webpackChunkName: "home" */ "@/views/home/index.vue"),
//         meta: {
//           title: " 首页 ",
//         },
//       },
//     ],
//   },
// ];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  // routes: screenW >= 768 ? routes : routesMobile,
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
